// Side-Effect-Import: das Paket hängt iFrameResize aufs window-Objekt.
import 'iframe-resizer';

export function initIframeResizer() {
  if (!document.querySelector('#dienstplan')) return;

  // iFrameResize wird vom 'iframe-resizer'-Paket als Global aufs window
  // gehängt (Side-Effect des Imports).
  // eslint-disable-next-line no-undef
  return iFrameResize(
    {
      log: false,
      enablePublicMethods: true, // Methoden innerhalb der iframe-Seite freigeben
      autoResize: true,
      checkOrigin: false,
      sizeHeight: true,
      sizeWidth: false,
    },
    '#dienstplan'
  );
}
